import React, { useState } from "react";

const Level4Match = ({ question, remainingSeconds, submitting, onSubmit }) => {
  const [selectedLeft, setSelectedLeft] = useState(null);
  const [pairs, setPairs] = useState([]); // [{leftId, rightId}]

  const pairedLeftIds = pairs.map((p) => p.leftId);
  const pairedRightIds = pairs.map((p) => p.rightId);

  const handleLeftClick = (leftId) => {
    if (pairedLeftIds.includes(leftId)) return;
    setSelectedLeft(leftId);
  };

  const handleRightClick = (rightId) => {
    if (!selectedLeft || pairedRightIds.includes(rightId)) return;
    setPairs((prev) => [...prev, { leftId: selectedLeft, rightId }]);
    setSelectedLeft(null);
  };

  const handleReset = () => {
    setPairs([]);
    setSelectedLeft(null);
  };

  const handleSubmit = () => {
    onSubmit({ selectedPairs: pairs });
  };

  const allPaired = pairs.length === question.payload.leftItems.length;

  return (
    <div className="rounded-3xl bg-white/5 border border-white/10 p-8 max-w-3xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <span className="text-xs uppercase tracking-widest text-emerald-300">
          {question.category}
        </span>
        <span className="text-2xl font-black text-yellow-300">
          ⏱ {remainingSeconds ?? "--"}s
        </span>
      </div>

      <h2 className="text-lg font-bold text-center mb-6 text-cyan-200">
        Match each picture on the left to its pair on the right
      </h2>

      <div className="grid grid-cols-2 gap-8">
        <div className="space-y-3">
          {question.payload.leftItems.map((img) => (
            <button
              key={img.id}
              onClick={() => handleLeftClick(img.id)}
              disabled={pairedLeftIds.includes(img.id)}
              className={`w-full rounded-2xl py-5 text-4xl border transition-all ${
                selectedLeft === img.id
                  ? "bg-emerald-500/30 border-emerald-400"
                  : pairedLeftIds.includes(img.id)
                  ? "bg-white/5 border-white/5 opacity-30"
                  : "bg-white/5 border-white/10 hover:bg-white/10"
              }`}
            >
              {img.emoji}
            </button>
          ))}
        </div>

        <div className="space-y-3">
          {question.payload.rightItems.map((img) => (
            <button
              key={img.id}
              onClick={() => handleRightClick(img.id)}
              disabled={pairedRightIds.includes(img.id) || !selectedLeft}
              className={`w-full rounded-2xl py-5 text-4xl border transition-all ${
                pairedRightIds.includes(img.id)
                  ? "bg-white/5 border-white/5 opacity-30"
                  : "bg-white/5 border-white/10 hover:bg-white/10 disabled:opacity-40"
              }`}
            >
              {img.emoji}
            </button>
          ))}
        </div>
      </div>

      <div className="flex gap-3 mt-6">
        <button
          onClick={handleReset}
          className="flex-1 rounded-2xl py-3 bg-white/5 border border-white/10 font-semibold"
        >
          Reset
        </button>
        <button
          onClick={handleSubmit}
          disabled={!allPaired || submitting}
          className="flex-1 rounded-2xl py-3 bg-gradient-to-r from-emerald-500 to-green-600 font-bold disabled:opacity-40"
        >
          {submitting ? "Submitting..." : "Submit Matches"}
        </button>
      </div>
    </div>
  );
};

export default Level4Match;
